var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0V4.80156H5L10 10.8599L15 4.80156H12.3718V0H7.5ZM3.26923 7.76628L0.352563 12.4067C0.192307 12.7934 -1.13249e-06 13.5346 -1.13249e-06 13.9858V22.9121C-1.13249e-06 23.3955 0.384614 23.75 0.833332 23.75H19.1346C19.6154 23.75 20 23.3955 20 22.9121V13.9858C20 13.5346 19.8397 12.7934 19.6795 12.4067L16.7628 7.76628C16.6026 7.34735 16.0256 6.99288 15.609 6.99288H14.2949L12.9487 8.63636H15.641L18.2372 13.4057C18.2692 13.4057 18.2692 13.4379 18.2692 13.4701C18.2692 13.5346 18.2692 13.5668 18.3013 13.599H1.73077V13.4701C1.73077 13.4379 1.76282 13.4057 1.76282 13.3735L4.35897 8.63636H7.05128L5.70513 6.99288H4.42308C3.97436 6.99288 3.42949 7.34735 3.26923 7.76628ZM12.3397 17.0794H7.6282C7.21154 17.0794 6.82692 16.6927 6.82692 16.2415C6.82692 15.8226 7.21154 15.4359 7.6282 15.4359H12.3397C12.7885 15.4359 13.1731 15.8226 13.1731 16.2415C13.1731 16.6927 12.7885 17.0794 12.3397 17.0794Z",
    fill: "none"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 23.75,
    fill: "none",
    transform: "matrix(-1 0 0 1 20 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.0fd257b3.svg";
export { ForwardRef as ReactComponent };